<template>
  <div>
    <div class="dim-group" v-for="group in groups" :key="group.label">
      <div class="dim-group-label" :class="group.tone">🔴 {{ group.label }}（{{ group.sub }}）</div>
      <div class="dim-cards">
        <button
          v-for="d in group.items"
          :key="d.code"
          class="dim-card"
          :class="{ covered: isCovered(d.code) }"
          type="button"
          :title="d.hint"
          @click="$emit('fill', d.template)"
        >
          <b>{{ d.code }}</b> {{ d.name }}
        </button>
      </div>
    </div>
    <p class="hint" style="margin-top:8px">💡 点击任意维度卡片，追问话术自动填入输入框；<span class="covered-mark">高亮</span>为已覆盖维度</p>
  </div>
</template>

<script>
// OPQRST / SAMPLE 可点击维度卡片。covered: 已命中维度代码数组（驱动高亮）
const GROUPS = [
  {
    label: 'OPQRST', sub: '疼痛/症状', tone: 'red',
    items: [
      { code: 'O', name: '发作', template: '您这个症状是什么时候开始的？当时正在做什么？' },
      { code: 'P', name: '诱因', template: '有什么诱因会让症状加重或缓解吗？比如活动、进食或休息？' },
      { code: 'Q', name: '性质', template: '这种不舒服是什么感觉的？像压榨、刺痛还是烧灼样？' },
      { code: 'R', name: '放射', template: '疼痛会向其他部位放射吗？比如肩膀、后背或手臂？' },
      { code: 'S', name: '严重度', template: '如果 0 到 10 分打分，您觉得症状有几分？影响日常活动吗？' },
      { code: 'T', name: '时间', template: '症状是持续的还是一阵阵的？每次持续多久？' },
    ],
  },
  {
    label: 'SAMPLE', sub: '系统回顾', tone: 'blue',
    items: [
      { code: 'A', name: '过敏', template: '您对什么药物或食物过敏吗？' },
      { code: 'M', name: '用药', template: '您目前一直在服用什么药物吗？' },
      { code: 'P史', name: '既往史', template: '以前有什么疾病史或手术史吗？' },
      { code: 'L', name: '最后进食', template: '最后一次吃东西是什么时候？吃了什么？' },
      { code: 'E', name: '事件经过', template: '从发病到现在，整个过程是怎么发展的？' },
    ],
  },
];

export default {
  name: 'DimensionCard',
  props: {
    covered: { type: Array, default: () => [] },
  },
  data: () => ({ groups: GROUPS }),
  methods: {
    isCovered(code) { return this.covered.includes(code); },
  },
};
</script>

<style scoped>
.dim-group { margin-bottom: 12px; }
.dim-group-label { font-size: 12px; font-weight: 600; margin-bottom: 8px; }
.dim-group-label.red { color: var(--danger); }
.dim-group-label.blue { color: var(--accent); }
.dim-cards { display: flex; flex-wrap: wrap; gap: 8px; }
.dim-card { background: var(--bg-2); border: 1px solid var(--border-1); color: var(--text-2); border-radius: var(--radius-s); padding: 8px 14px; font-size: 12px; cursor: pointer; transition: all 0.2s; }
.dim-card b { color: var(--accent); margin-right: 4px; }
.dim-card:hover { color: var(--text-1); border-color: var(--primary-2); transform: translateY(-1px); }
.dim-card.covered { background: var(--success-a10); border-color: var(--success-a40); color: var(--success); }
.dim-card.covered b { color: var(--success); }
.covered-mark { color: var(--success); }
</style>
